import { render, staticRenderFns } from "./cModalPreviewOc.vue?vue&type=template&id=1835e4eb"
import script from "./cModalPreviewOc.vue?vue&type=script&lang=js"
export * from "./cModalPreviewOc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports